<template>
    <div :class="wrapClasses" :style="wrapStyles" v-show="showModal" :id="wrapperId">
        <div slot="mask" :class="maskClasses" v-if="showMask" v-show="showModal" :style="maskWrapStyles" @click="handleMask"></div>
        <div :class="contentClasses" ref="content" v-if="showModal" :style="contentWrapStyles">
            <a :class="[prefixCls + '-close']" v-show="closeAble" @click.stop="close" href="javascript:void(0)">
                <slot name="close">
                    <i :class="[prefixCls + '-icon-close']" />
                </slot>
            </a>
            <div :class="[prefixCls + '-header']" v-if="showHead">
                <slot name="header">
                    <div :class="[prefixCls + '-header-inner']">{{ title }}</div>
                </slot>
            </div>
            <div :class="[prefixCls + '-body']">
                <slot>内容</slot>
            </div>
            <div :class="[prefixCls + '-footer']" v-if="showFooter">
                <slot name="footer">
                    <div :class="[prefixCls + '-footer-content']">
                        <a href="javascript:void(0)" :class="[prefixCls + '-btn-cancel']" @click.stop="cancel">{{ cancelText }}</a>
                        <a href="javascript:void(0)" :class="[prefixCls + '-btn-confirm']" @click.stop="ok">{{ okText }}</a>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",
    data() {
        return {
            showModal: false
        };
    },
    props: {
        id: {
            type: String,
            default: ""
        },
        visible: {
            type: Boolean,
            default: false
        },
        prefixCls: {
            type: String,
            default: "tm-modal"
        },
        closeAble: {
            type: Boolean,
            default: true
        },
        maskCloseAble: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "标题"
        },
        width: {
            type: [Number, String],
            default: 280
        },
        okText: {
            type: String,
            default: "确定"
        },
        cancelText: {
            type: String,
            default: "取消"
        },
        className: {
            type: String
        },
        // for instance
        showHead: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        // scrollable: {
        //     type: Boolean,
        //     default: false
        // },
        mask: {
            type: Boolean,
            default: true
        },
        zIndex: {
            type: Number,
            default: 1000
        }
    },
    computed: {
        maskClasses() {
            const prefixCls = this.prefixCls;
            return `${prefixCls}-mask`;
        },
        showMask() {
            return this.mask;
        },
        contentClasses() {
            const prefixCls = this.prefixCls;
            return [
                `${prefixCls}-content`,
                {
                    [`${prefixCls}-content-no-mask`]: !this.showMask
                }
            ];
        },
        wrapClasses() {
            const prefixCls = this.prefixCls;
            return [
                prefixCls + "-wrapper",
                {
                    [`${this.className}`]: !!this.className
                }
            ];
        },
        wrapStyles() {
            return {
                zIndex: this.zIndex
            };
        },
        maskWrapStyles() {
            return {
                zIndex: this.zIndex + 1
            };
        },
        contentWrapStyles() {
            return {
                zIndex: this.zIndex + 100
            };
        },
        wrapperId() {
            return this.id || "tmModal" + new Date().getTime();
        }
    },
    beforeMount() {
        this.showModal = this.visible;
    },
    methods: {
        close() {
            this.showModal = false;
            this.$emit("on-cancel");
            this.$emit("update:visible", false);
        },
        handleMask() {
            if (this.maskCloseAble && this.showMask) {
                this.close();
            }
        },
        cancel() {
            this.close();
        },
        ok() {
            this.$emit("on-ok");
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler(val) {
                this.showModal = val;
            }
        }
    }
};
</script>

<style lang="less">
@prefixCls: .tm-modal;

@{prefixCls}-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
@{prefixCls}-mask {
    background: #000;
    background: rgba(0, 0, 0, 0.3);
    filter: alpha(opacity=30);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}
@{prefixCls}-content {
    width: 280px;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
}
@{prefixCls}-header {
    position: relative;
}
@{prefixCls}-header-inner {
    height: 56px;
    font-size: 16px;
    line-height: 56px;
    color: #333333;
    text-align: center;
}
@{prefixCls}-close {
    position: absolute;
    outline: none;
    text-decoration: none;
    right: 12px;
    top: 12px;
    padding: 8px;
    z-index: 100;
}
@{prefixCls}-icon-close {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("../../assets/images/components/modal/icon_delete.png") center center no-repeat;
    background-size: 12px 12px;
}
@{prefixCls}-body {
    font-size: 14px;
    line-height: 24px;
    color: #888888;
    padding: 0 20px 24px;
    text-align: justify;
}
@{prefixCls}-footer {
}
@{prefixCls}-footer-content {
    display: flex;
    flex-direction: row;
}
@{prefixCls}-btn-cancel {
    flex: 1;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    color: #aaaaaa;
    text-decoration: none;
    text-align: center;
    border-top: 1px solid #ebebeb;
    border-right: 1px solid #ebebeb;
}
@{prefixCls}-btn-confirm {
    flex: 1;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    color: #c0a266;
    text-decoration: none;
    text-align: center;
    border-top: 1px solid #ebebeb;
}
</style>
